import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'

document.title='Calculator';

createApp(App).mount('#app')
